// extracted by mini-css-extract-plugin
export default {"notice":"MarketNotice_notice__8f3Vd","text":"MarketNotice_text__KWrOW","link":"MarketNotice_link__Q3aRW","close":"MarketNotice_close__mFzQ2"};